module.exports = {
    schemeForResult: false
};


//////////////////
// WEBPACK FOOTER
// ../plugins/ctrip/apis/scheme.js
// module id = 51
// module chunks = 1 4